import React, { useRef } from 'react'

export function GalleryAddPreview ({ data }) {
    const imgRef = useRef()

    if ( data.invalid ) {
        return (<>Arquivo invalido</>)
    }

    const reader = new FileReader();
    reader.readAsDataURL(data);
    reader.onload = function(e) {
        imgRef.current.src = e.target.result
    }

    return <img ref={imgRef} className="w-100 h-md-150px" alt="" />
}